import {Component} from '@angular/core';
import {DialogBase} from '@shared/helper/dialog-base';
import {FormGroup} from '@angular/forms';
import {FormlyFieldConfig} from '@ngx-formly/core';

interface InputParam {
    fields: FormlyFieldConfig[];
    model: any;
    btnLabel?: string;
}

@Component({
    selector: 'app-input-dialog',
    template: `
        <p-card>
            <div class="centered-content">
                <form [formGroup]="formGroup" class="w-11">
                    <formly-form [model]="data?.model" [fields]="data.fields" [form]="formGroup">
                    </formly-form>
                    <hr>
                    <div class="text-center mt-3">
                        <button pButton type="button"
                                [label]="data?.btnLabel || 'Continue'"
                                icon="pi pi-chevron-right"
                                iconPos="right"
                                class="p-button-success p-button-lg"
                                [disabled]="!formGroup.valid"
                                (click)="onSubmit()"
                        >
                        </button>
                    </div>
                </form>
            </div>
<!--            <app-json-viewer [model]="data?.model"></app-json-viewer>-->
        </p-card>
    `,
    styles: []
})
export class InputDialogComponent extends DialogBase<InputParam> {
    formGroup = new FormGroup({});

    onSubmit() {
        super.close(this.data.model);
    }
}
